/**
 * Swaps the browser-tab favicon for an environment-tinted variant on every non-prod host, so you can
 * tell local / dev / staging apart at a glance. In production this is a no-op — the theme-adaptive
 * light/dark icons from nuxt.config stay in place.
 *
 * THIS USED TO MANIPULATE THE DOM DIRECTLY, AND IT SILENTLY DID NOTHING.
 *
 * The old version did `head.querySelectorAll('link[rel="icon"]').forEach(l => l.remove())` and then
 * appended its own <link>. Nuxt does not treat the DOM as the source of truth for head tags: unhead
 * owns them, and on hydration it re-applies what nuxt.config declared — putting the prod icons back
 * and dropping the one this plugin added. The result was that EVERY environment, local and dev
 * included, quietly served the production favicon. Verified on dev.holamarcus.com, where the icon
 * links read `/favicon.svg?v=5` + `/favicon-dark.svg?v=5` rather than `/favicon-dev.svg`.
 *
 * So it goes through `useHead` instead, keyed to the same `key`s nuxt.config gives those two links.
 * Matching keys is what makes these entries REPLACE rather than append — remove the keys on either
 * side and the bug comes straight back, with no error to notice.
 *
 * Both keys get the same file on purpose: the env tint is a flat colour that reads on either
 * browser theme, so there is no light/dark pair to select between.
 */
export default defineNuxtPlugin(() => {
  const env = detectAppEnv()
  if (env === 'prod') return

  const href = `/favicon-${env}.svg?v=7`

  useHead({
    link: [
      { key: 'favicon-light', rel: 'icon', type: 'image/svg+xml', href },
      { key: 'favicon-dark', rel: 'icon', type: 'image/svg+xml', href },
      // The root .ico link (nuxt.config `favicon-ico`) must not leak the prod mark either: same key,
      // pointed at the tint. It carries no `type`, so the "exactly two svg icon links" case is unchanged.
      { key: 'favicon-ico', rel: 'icon', href, sizes: 'any', media: '(prefers-color-scheme: light)' },
    ],
  })
})
